import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface LinhaQualidadeTopo {
  usuario_id: string; nome: string; fila: string; ordem: number;
  hoje: number; no_prazo: number | null; fora: number | null;
  pct: number | null; piso: number | null; valor: number; bateu: boolean;
}
export interface QualidadePainelTopo {
  competencia: string;
  trava: { ativo?: boolean; ok?: boolean; realizado?: number; minimo?: number } | null;
  linhas: LinhaQualidadeTopo[];
}

/**
 * O chip "Qualidade" do topo (Douglas 28/09/2026): uma linha por pessoa, do
 * contrato à fatura — hoje, no prazo, fora, % × piso e o valor. Fonte:
 * `fn_qualidade_painel_topo`, que lê as mesmas medidas da comissão.
 */
export function useQualidadePainelTopo(habilitado: boolean) {
  return useQuery<QualidadePainelTopo>({
    queryKey: ['qualidade-painel-topo'],
    enabled: habilitado,
    refetchInterval: 5 * 60_000,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('fn_qualidade_painel_topo' as never);
      if (error) throw error;
      const bruto = (data ?? {}) as Partial<QualidadePainelTopo>;
      return { competencia: bruto.competencia ?? '', trava: bruto.trava ?? null, linhas: Array.isArray(bruto.linhas) ? bruto.linhas : [] };
    },
  });
}
